import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { dataOrThrow, type GetPortalOrdersQuery } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

/**
 * Loads the signed-in member's orders via `GET /api/portal/orders`,
 * newest first. `status` narrows the response (the home-page
 * notification card asks for `['prepared']`); omitting it returns
 * orders in every status.
 */
export function useListOrders(
  params: Partial<GetPortalOrdersQuery> = {},
  options: { enabled?: boolean; keepPreviousData?: boolean } = {}
) {
  const api = usePortalApi()
  return useQuery({
    queryKey: ['portal-orders', params],
    enabled: options.enabled ?? true,
    placeholderData: options.keepPreviousData ? keepPreviousData : undefined,
    queryFn: async () => dataOrThrow(await api.get('/orders', { query: params })),
  })
}
